import { API_BASE } from '../utils/config';

export const requestOtp = async (mobile: string): Promise<{ success: boolean; userExists: boolean; message?: string }> => {
  try {
    const res = await fetch(`${API_BASE}/otp/request?mobile=${mobile}&country_code=91`);
    const data = await res.json();
    return { success: res.ok, userExists: !!data.user_exists, message: data.message };
  } catch {
    return { success: false, userExists: false, message: 'Network error' };
  }
};

export const verifyOtp = async (mobile: string, otp: string): Promise<{ success: boolean; token?: string; userId?: string; role?: string; refreshToken?: string; orgPreferences?: any }> => {
  try {
    const res = await fetch(`${API_BASE}/otp/verify?mobile=${mobile}&country_code=91&otp_code=${otp}`);
    const data = await res.json();
    if (res.ok) {
      return {
        success: true,
        token: data.token,
        userId: data.user_id,
        role: data.role,
        refreshToken: data.refresh_token,
        orgPreferences: data.org_preferences,
      };
    }
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const signUp = async (payload: {
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
  country_code: string;
  gender: string;
}): Promise<{ success: boolean; message?: string }> => {
  try {
    const res = await fetch(`${API_BASE}/customers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return { success: res.ok, message: data.message };
  } catch {
    return { success: false, message: 'Network error' };
  }
};
